const key = "new-proxy";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/[0-9]*\/proxies$/);
};

const modify = (resp) => {
	const currentProxies = resp.data.Data;

	currentProxies.push(
		{
			Id: -1,
			Code: "fake json",
			Name: "Fake Json Response",
			Type: {
				Id: 3,
				Code: "QUERY",
				Name: "Query",
				Description: "Query / Get Information"
			}
		},
		{
			Id: -2,
			Code: "fake or",
			Name: "Fake Operation Result Response",
			Type: {
				Id: 3,
				Code: "QUERY",
				Name: "Query",
				Description: "Query / Get Information"
			}
		}
	);

	return resp;
};

export const addNewProxy = [key, applicable, modify];